export { default } from './TimelineSeparator';
export type * from './TimelineSeparator';

export { default as timelineSeparatorClasses } from './timelineSeparatorClasses';
export * from './timelineSeparatorClasses';
